module.exports = __webpack_public_path__ + "img/left1Icon3.2a8f3382.png";